import sc from 'styled-components';

export const wrapperStyled = sc.div`
    display: flex;
    flex-direction: column;
`;

export const Wrapper = sc.div<{$gap?: boolean}>`
    display: flex;
    flex-direction: column;
    position: relative;
    gap: ${({$gap}) => ($gap ? 5 : 0)}px;
`;